define('helperNavigation-areChildrenVisited',[],function() {
    'use strict';

    // Checks if pages and all their sub paged visited
    var areChildrenVisited = function f(children, user) {
        var visited = true;
        if (!Array.isArray(children)) {
            return null;
        }

        if(children.length > 0){
            for (var i=0;i<children.length;i++) {
                if(!user.isPageVisitedById(children[i].contentEntityId)) {
                    visited = false;
                    break;
                } else {
                    if (children[i].hasOwnProperty('children') && Array.isArray(children[i].children) && children[i].children.length) {
                        if (!areChildrenVisited(children[i].children, user)) {
                            visited = false;
                        }
                    }
                }
            }
        }

        return visited;
    };

    return areChildrenVisited;
});

